import React, { useState } from "react";
import { API_BASE_URL } from "./constants/adminConstants";
import "./css/adminStyles.css";

function AdminLogin({ onLogin }) {
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ loginId, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error || "Login failed.");
        setLoading(false);
        return;
      }

      sessionStorage.setItem("tvc_token", data.token);
      sessionStorage.setItem("tvc_user", JSON.stringify(data.user));
      if (onLogin) onLogin(data.user);
    } catch (err) {
      setError("Server error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="AdminLoginPage">
      <div className="AdminLoginBox">
        <p className="AdminLoginSubtitle">Sign in to your account</p>

        <form onSubmit={handleSubmit}>
          <div className="AdminFormGroup">
            <label className="AdminLabel">Login ID</label>
            <input
              className="AdminInput"
              type="text"
              placeholder="Samaksh.AdminTCV.com"
              value={loginId}
              onChange={(e) => setLoginId(e.target.value)}
              required
              autoComplete="username"
            />
          </div>

          <div className="AdminFormGroup">
            <label className="AdminLabel">Password</label>
            <div className="AdminPwInputWrap">
              <input
                className="AdminInput AdminPwInput"
                type={showPassword ? "text" : "password"}
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
              <button type="button" className="AdminPwToggle" onClick={() => setShowPassword(!showPassword)} tabIndex={-1}>
                {showPassword ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                )}
              </button>
            </div>
          </div>

          <div className="AdminForgotRow">
            <a href={`/admin/forgot-password${loginId ? "?loginId=" + encodeURIComponent(loginId) : ""}`} className="AdminLink" style={{ fontSize: 13 }}>Forgot Password?</a>
          </div>

          {error && <p className="AdminError">{error}</p>}

          <button className="AdminButton" type="submit" disabled={loading}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <div className="AdminTextCenter">
          <a href="/admin/signup" className="AdminLink">Create an account</a>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;
